/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Integration_Import_SummaryInputs */

const en_integration_import_summary = /** @type {(inputs: Integration_Import_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Files queued for conversion: ${i?.count}. They will appear in your library.`)
};

const es_integration_import_summary = /** @type {(inputs: Integration_Import_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Archivos en cola para convertir: ${i?.count}. Aparecerán en tu biblioteca.`)
};

/**
* | output |
* | --- |
* | "Files queued for conversion: {count}. They will appear in your library." |
*
* @param {Integration_Import_SummaryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const integration_import_summary = /** @type {((inputs: Integration_Import_SummaryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integration_Import_SummaryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_integration_import_summary(inputs)
	return en_integration_import_summary(inputs)
});